"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSecureInput = void 0;
var react_1 = require("react");
var use_secure_fields_1 = require("./use-secure-fields");
var addFieldFns = {
    number: 'addCardNumberField',
    expiryDate: 'addExpiryDateField',
    securityCode: 'addSecurityCodeField',
};
var useSecureInput = function (options) {
    var secureFields = (0, use_secure_fields_1.useSecureFields)().secureFields;
    var _a = (0, react_1.useState)(), field = _a[0], setField = _a[1];
    var ref = options.ref, type = options.type, onBlur = options.onBlur, onFocus = options.onFocus, onInput = options.onInput, rest = __rest(options, ["ref", "type", "onBlur", "onFocus", "onInput"]);
    var addField = function (type) {
        if (!secureFields || !(options === null || options === void 0 ? void 0 : options.ref) || field) {
            return;
        }
        return secureFields[addFieldFns[type]](ref.current, __assign({}, rest));
    };
    (0, react_1.useEffect)(function () {
        setField(addField(options === null || options === void 0 ? void 0 : options.type));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [secureFields]);
    (0, react_1.useEffect)(function () {
        if (!field)
            return;
        onBlur && field.addEventListener('blur', onBlur);
        onFocus && field.addEventListener('focus', onFocus);
        onInput && field.addEventListener('input', onInput);
        return function () {
            onBlur && field.addEventListener('blur', onBlur);
            onFocus && field.addEventListener('focus', onFocus);
            onInput && field.addEventListener('input', onInput);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [secureFields, field]);
    return field;
};
exports.useSecureInput = useSecureInput;
//# sourceMappingURL=use-secure-input.js.map